import React from 'react'
import { Trans } from '@lingui/macro'
import { REDIRECT, MANUAL } from '../../constants/closeTypes'
import { Ellipsis } from '../../components/Animation'

const getContentByCloseType = (closeType) => {
  const mapping = {
    [MANUAL]: { accepted: <Ellipsis><Trans>Share successful</Trans></Ellipsis> },
    [REDIRECT]: { accepted: <Ellipsis><Trans>Redirecting shortly</Trans></Ellipsis> }
  }

  return mapping[closeType]
}

const getContent = ({ closeType }) => {
  const contentByCloseType = getContentByCloseType(closeType)

  return {
    accepted: '', /* you should never get an accepted state without closeType, but just in case we removed the text */
    title: <Trans>Scan with the Yoti app:</Trans>,
    error: <Trans>Error</Trans>,
    expired: <Trans>Expired</Trans>,
    retryButton: <Trans>Click to refresh</Trans>,
    loading: <Trans>Loading...</Trans>,
    ...contentByCloseType
  }
}

export default getContent
